
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__pero",
  "use": "icon__pero-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__pero\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"currentColor\" d=\"M21.75 3c-5.184 0-8.774 1.088-10.67 3.234-1.148 1.3-1.324 2.63-1.336 3.25-.704.792-1.575 2.054-1.887 2.516H5.25a.75.75 0 0 0-.75.75V15h-.75c-1.24 0-2.25 1.01-2.25 2.25v1.5C1.5 19.99 2.51 21 3.75 21h9c1.24 0 2.25-1.01 2.25-2.25v-1.5c0-1.24-1.01-2.25-2.25-2.25H12v-2.25a.75.75 0 0 0-.75-.75H9.688c.418-.587.818-1.107 1.16-1.491.153.008.181.017.466.017 2.387 0 8.898-.563 11.14-6.512A.755.755 0 0 0 21.75 3zm-1.172 1.52c-2.283 4.211-7.374 4.556-9.29 4.518.087-.474.327-1.156.95-1.846 1.031-1.141 3.312-2.49 8.34-2.671zM6 13.5h4.5v2.25c0 .414.336.75.75.75h1.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 0 .75-.75V13.5z\" /><path d=\"M0 0h24v24H0z\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconPeroIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__pero" {...restProps} />
    })
  